/**
 * Заголовки админских запросов к site_server.
 *
 * Админа сервер узнаёт по подписанному `site_session_token`: `X-Admin-Email` может
 * поставить кто угодно, и он действует, только пока сервер в режиме ADMIN_AUTH_MODE=dual.
 * Воркеры бакета этот токен не проверяют — им нужна своя сессия (`authedFetch`).
 */

/** Пустая строка — не вошёл или смотрит «войти как» (там токен сессии пустой). */
export const siteSessionToken = (): string => {
    try {
        return (localStorage.getItem("site_session_token") || "").trim();
    } catch {
        return "";
    }
};

export const adminHeaders = (adminEmail: string): Record<string, string> => {
    const token = siteSessionToken();
    return {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "X-Admin-Email": adminEmail,
    };
};
